export const accessoriesProduct = () => {
    document.addEventListener('DOMContentLoaded', () => {

        document.addEventListener('gpoRenderCompleted', () => {
            let stickyBarSubmit = document.querySelector(".product-sticky-bar .stickybar-submit");
            stickyBarSubmit.setAttribute('type', 'button');
            stickyBarSubmit.classList.add("has-accessories");
            stickyBarSubmit.innerHTML = "オプションを選択";

            document.querySelector(".stickybar-submit.has-accessories").addEventListener("click", function(){
                const element = document.querySelector('.gpo-container');
                const y = element.getBoundingClientRect().top + window.pageYOffset - 120;
                window.scrollTo({top: y, behavior: 'smooth'});
            })

            let listSwatches = document.querySelectorAll(".gpo-app .gpo-swatches input");
            listSwatches.forEach((element) => {
                const handle = element.getAttribute('gpo-data-product-handle');
                const variant_id = element.getAttribute('gpo-data-variant-id');
                if(handle && variant_id){
                    getProductVariant(handle, variant_id).then((variant) => {
                        if(!variant.available){
                            element.closest(".gpo-swatches").classList.add("disabled");
                            element.closest(".gpo-swatches").insertAdjacentHTML('beforeend', '<span class="outstock-label">在庫切れ</span>');
                        }
                        element.closest(".gpo-swatches").insertAdjacentHTML('beforeend', '<a class="detail-access" target="_blank" href="' + variant.variant_url +'"><svg fill=#000000 height=20px viewBox="0 0 24 24" width=20px xmlns=http://www.w3.org/2000/svg><path d=M15,10H12V7a1,1,0,0,0-2,0v3H7a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V12h3a1,1,0,0,0,0-2Zm6.71,10.29L18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z /></svg></a>');

                        // element.closest(".gpo-swatches").querySelector('.detail-access').addEventListener("click", function(e){
                        //     e.preventDefault();
                        //     // console.log(1);
                        //     const accessoriesItem = this.closest(".gpo-swatches");
                        //     let body = document.querySelector("body");
                        //     document.documentElement.classList.add("accessories-popup-opened");
                        //     const popupElement = '<div class="accessories-popup">'+
                        //                             '<div class="popup-body">'+ 
                        //                                 '<button class="cclose-popup"></button>'+
                        //                                 '<div class="accossories-item">'+
                        //                                     '<div class="caption">'+
                        //                                         accessoriesItem.querySelector(".gpo-tooltip__title").innerHTML +
                        //                                     '</div>'+
                        //                                     '<div class="thumbnail">'+ accessoriesItem.querySelector(".gpo-swatch__inner").innerHTML +'</div>'+
                        //                                     '<div class="detail-button"><a target="_blank" href="'+ variant.variant_url +'">商品詳細を見る</a></div>'+
                        //                                 '</div>'+
                        //                             '</div>' +
                        //                         '</div>';
                        //     body.insertAdjacentHTML('beforeend', popupElement);
                        //     document.querySelector(".cclose-popup").addEventListener("click", function(){
                        //         document.documentElement.classList.remove("accessories-popup-opened");
                        //         document.querySelector(".accessories-popup").remove();
                        //     })
                        // })

                    })
                }
                element.addEventListener("change", function(){
                    let wrap = element.closest(".gpo-ov-wrapper");
                    let wrap2 = element.closest(".show-addon-for-option");
                    if(this.checked){
                        let noChoice = wrap.querySelector(".no-choice");
                        if(!noChoice){
                            wrap.insertAdjacentHTML('beforeend', '<div class="gpo-swatches image-swatches no-choice"><a class="btn-no-choose" href="#">買わない</a></div>');
                        }else{
                            noChoice.classList.remove("active");
                        }
                        wrap.querySelector(".btn-no-choose").addEventListener("click", function(e){
                            e.preventDefault();
                            this.closest(".no-choice").classList.add("active");
                            wrap.querySelectorAll("input").forEach(function(input){
                                if(input.checked){
                                    input.dispatchEvent(new Event('click'))
                                }
                            })
                        })
                        wrap2.querySelector(".group-selected .value").innerHTML = element.value;
                        wrap2.querySelector(".group-selected").classList.remove("no-c");
                    }else{
                        if(wrap.querySelector(".no-choice")){
                            wrap.querySelector(".no-choice").classList.add("active");
                        }
                        wrap2.querySelector(".group-selected .value").innerHTML = "選択されていません";
                        wrap2.querySelector(".group-selected").classList.add("no-c");
                    }
                })
            })

            let groupAccess = document.querySelectorAll(".gpo-app .show-addon-for-option");
            groupAccess.forEach((element) => {
                element.insertAdjacentHTML('beforeend', '<div class="group-selected"><span class="label">選択中：</span><span class="value">選択されていません</span></div>');
            })
            
            //Remove class "price-list"
            document.querySelector(".product-info price-list").classList.remove("price-list");

            let totalText = document.querySelector(".gpo-total .gpo-total-text");
            if(totalText){
                const money = document.querySelector(".product-info price-list sale-price").innerHTML;
                totalText.classList.add("price-list");
                totalText.innerHTML = '';
                totalText.insertAdjacentHTML('beforeend', '<span class="text">合計価格： </span><sale-price class="tprice">'+ money +'</sale-price> <small style="font-size: 95%">(税込)</small>');
            }

        })

        async function getProductVariant(handle, variantId){
            var product = await ProductLoader.load(handle);
            let variant = product["variants"].find((variant) => variant.id == variantId);
            variant['variant_url'] = product.url + '?variant=' + variant.id;
            return variant;
        }

        var loadedProducts = {};
        var ProductLoader = class {
            static load(productHandle) {
                if (!productHandle) {
                    return;
                }
                if (loadedProducts[productHandle]) {
                    return loadedProducts[productHandle];
                }
                loadedProducts[productHandle] = new Promise(async (resolve, reject) => {
                    const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
                    if (response.ok) {
                        const responseAsJson = await response.json();
                        resolve(responseAsJson);
                    } else {
                        reject(`
                        Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
                        switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
                        to "active".
                        `);
                    }
                });
                return loadedProducts[productHandle];
            }
        };

    })
}